import { useApolloClient } from "@apollo/client";
import { useGetProductAssetUploadUrlMutation } from "./useProductAssetUpload.generated.js";
import React from "react";

export const useProductAssetUpload = () => {
  const client = useApolloClient();
  const [getUrl, { loading: loadingGetUploadUrl }] =
    useGetProductAssetUploadUrlMutation({ client });

  const getUploadUrl = React.useCallback(
    async ({
      filename,
      contentType,
    }: {
      filename: string;
      contentType: string;
    }) => {
      const result = await getUrl({
        variables: {
          input: {
            filename,
            contentType,
          },
        },
      });

      if (!result.data) {
        throw new Error("Failed to get upload URL");
      }

      return result.data.getProductAssetUploadUrl.uploadUrl;
    },
    [getUrl]
  );

  return {
    getUploadUrl,
    loading: loadingGetUploadUrl,
  };
};
